import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance_0,
} from '../statement/HttpResponsePipeline.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  SetupRequest_instance2wgomqglvou5t as SetupRequest_instance,
  Send_instance2se4t9sd7p3bp as Send_instance,
  Sender1wtdgti85uk42 as Sender,
} from './api/CommonHooks.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  HttpRequest3fsc4149kgwfg as HttpRequest,
  get_coroutineContext1djaai1ellg0c as get_coroutineContext,
} from '../request/HttpRequest.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER;
}
var LOGGER;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
var HttpCallValidatorConfigClass;
function HttpCallValidatorConfig() {
  if (HttpCallValidatorConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.i5t_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.j5t_1 = ArrayList().p2();
        this.k5t_1 = true;
      }
      l5t(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.i5t_1.i2(block);
      }
    }
    initMetadataForClass($, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
    HttpCallValidatorConfigClass = $;
  }
  return HttpCallValidatorConfigClass;
}
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.z5n(get_HttpCallValidator(), block);
}
var ExceptionHandlerWrapperClass;
function ExceptionHandlerWrapper() {
  if (ExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ExceptionHandlerWrapper');
    ExceptionHandlerWrapperClass = $;
  }
  return ExceptionHandlerWrapperClass;
}
var RequestExceptionHandlerWrapperClass;
function RequestExceptionHandlerWrapper() {
  if (RequestExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestExceptionHandlerWrapper');
    RequestExceptionHandlerWrapperClass = $;
  }
  return RequestExceptionHandlerWrapperClass;
}
var RequestError$install$slambdaClass;
function RequestError$install$slambda() {
  if (RequestError$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.c5v_1 = $handler;
      }
      *n5l($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.a4w($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            var error = yield* this.c5v_1(HttpRequest_0($this$intercept.x4w_1), cause, $completion);
            if (!(error == null))
              throw error;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.n5l(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RequestError$install$slambdaClass = $;
  }
  return RequestError$install$slambdaClass;
}
function RequestError$install$slambda_0($handler) {
  var i = new (RequestError$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.n5l($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var RequestErrorClass;
function RequestError() {
  if (RequestErrorClass === VOID) {
    class $ {
      d5v(client, handler) {
        var tmp = Phases_getInstance().f5s_1;
        client.u5l_1.b4x(tmp, RequestError$install$slambda_0(handler));
      }
      k5s(client, handler) {
        return this.d5v(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestError');
    RequestErrorClass = $;
  }
  return RequestErrorClass;
}
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
var ReceiveError$install$slambdaClass;
function ReceiveError$install$slambda() {
  if (ReceiveError$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.e5v_1 = $handler;
      }
      *k5m($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.a4w($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            var error = yield* this.e5v_1($this$intercept.x4w_1.h5o(), cause, $completion);
            if (!(error == null))
              throw error;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.k5m(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ReceiveError$install$slambdaClass = $;
  }
  return ReceiveError$install$slambdaClass;
}
function ReceiveError$install$slambda_0($handler) {
  var i = new (ReceiveError$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.k5m($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var ReceiveErrorClass;
function ReceiveError() {
  if (ReceiveErrorClass === VOID) {
    class $ {
      d5v(client, handler) {
        var BeforeReceive = new (PipelinePhase())('BeforeReceive');
        client.v5l_1.a4x(Phases_getInstance_0().e5n_1, BeforeReceive);
        client.v5l_1.b4x(BeforeReceive, ReceiveError$install$slambda_0(handler));
      }
      k5s(client, handler) {
        return this.d5v(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ReceiveError');
    ReceiveErrorClass = $;
  }
  return ReceiveErrorClass;
}
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest_0(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new (HttpRequest$1())(builder);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  var l = () => new (HttpCallValidatorConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.t5s_1.i5t_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.t5s_1.j5t_1);
  var expectSuccess = $this$createClientPlugin.t5s_1.k5t_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.w5s(tmp, HttpCallValidator$lambda$slambda_0(expectSuccess));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.w5s(tmp_0, HttpCallValidator$lambda$slambda_2(responseValidators));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.w5s(tmp_1, HttpCallValidator$lambda$slambda_4(callExceptionHandlers));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.w5s(tmp_2, HttpCallValidator$lambda$slambda_6(callExceptionHandlers));
  return Unit_instance;
}
function *invoke$validateResponse(responseValidators, response, $completion) {
  get_LOGGER().b4y('Validating response for request ' + response.o5o().h5o().q5o().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = responseValidators.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    yield* element(response, $completion);
  }
  return Unit_instance;
}
function *invoke$processException(callExceptionHandlers, cause, request, $completion) {
  get_LOGGER().b4y('Processing exception ' + cause.toString() + ' for request ' + request.q5o().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = callExceptionHandlers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ExceptionHandlerWrapper())
      yield* element.g5v_1(cause, $completion);
    else {
      if (element instanceof RequestExceptionHandlerWrapper())
        yield* element.f5v_1(cause, request, $completion);
      else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
var HttpCallValidator$lambda$slambdaClass;
function HttpCallValidator$lambda$slambda() {
  if (HttpCallValidator$lambda$slambdaClass === VOID) {
    class $ {
      constructor($expectSuccess) {
        this.h5v_1 = $expectSuccess;
      }
      *i5v(request, $completion) {
        var tmp = get_ExpectSuccessAttributeKey();
        request.v5n_1.p4r(tmp, () => this.h5v_1);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.i5v(p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpCallValidator$lambda$slambdaClass = $;
  }
  return HttpCallValidator$lambda$slambdaClass;
}
function HttpCallValidator$lambda$slambda_0($expectSuccess) {
  var i = new (HttpCallValidator$lambda$slambda())($expectSuccess);
  var l = (request, $completion) => i.i5v(request, $completion);
  l.$arity = 1;
  return l;
}
var HttpCallValidator$lambda$slambdaClass_0;
function HttpCallValidator$lambda$slambda_1() {
  if (HttpCallValidator$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($responseValidators) {
        this.j5v_1 = $responseValidators;
      }
      *k5v($this$on, request, $completion) {
        var call = yield* $this$on.n5v(request, $completion);
        yield* /*#__NOINLINE__*/invoke$validateResponse(this.j5v_1, call.h5m(), $completion);
        return call;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof Sender() ? p1 : THROW_CCE();
        return this.k5v(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpCallValidator$lambda$slambdaClass_0 = $;
  }
  return HttpCallValidator$lambda$slambdaClass_0;
}
function HttpCallValidator$lambda$slambda_2($responseValidators) {
  var i = new (HttpCallValidator$lambda$slambda_1())($responseValidators);
  var l = ($this$on, request, $completion) => i.k5v($this$on, request, $completion);
  l.$arity = 2;
  return l;
}
var HttpCallValidator$lambda$slambdaClass_1;
function HttpCallValidator$lambda$slambda_3() {
  if (HttpCallValidator$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($callExceptionHandlers) {
        this.o5v_1 = $callExceptionHandlers;
      }
      *p5v(request, cause, $completion) {
        var unwrappedCause = unwrapCancellationException(cause);
        yield* /*#__NOINLINE__*/invoke$processException(this.o5v_1, unwrappedCause, request, $completion);
        return unwrappedCause;
      }
      pd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest()) : false) ? p1 : THROW_CCE();
        return this.p5v(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpCallValidator$lambda$slambdaClass_1 = $;
  }
  return HttpCallValidator$lambda$slambdaClass_1;
}
function HttpCallValidator$lambda$slambda_4($callExceptionHandlers) {
  var i = new (HttpCallValidator$lambda$slambda_3())($callExceptionHandlers);
  var l = (request, cause, $completion) => i.p5v(request, cause, $completion);
  l.$arity = 2;
  return l;
}
var HttpCallValidator$lambda$slambdaClass_2;
function HttpCallValidator$lambda$slambda_5() {
  if (HttpCallValidator$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($callExceptionHandlers) {
        this.q5v_1 = $callExceptionHandlers;
      }
      *p5v(request, cause, $completion) {
        var unwrappedCause = unwrapCancellationException(cause);
        yield* /*#__NOINLINE__*/invoke$processException(this.q5v_1, unwrappedCause, request, $completion);
        return unwrappedCause;
      }
      pd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest()) : false) ? p1 : THROW_CCE();
        return this.p5v(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpCallValidator$lambda$slambdaClass_2 = $;
  }
  return HttpCallValidator$lambda$slambdaClass_2;
}
function HttpCallValidator$lambda$slambda_6($callExceptionHandlers) {
  var i = new (HttpCallValidator$lambda$slambda_5())($callExceptionHandlers);
  var l = (request, cause, $completion) => i.p5v(request, cause, $completion);
  l.$arity = 2;
  return l;
}
var HttpRequest$1Class;
function HttpRequest$1() {
  if (HttpRequest$1Class === VOID) {
    class $ {
      constructor($builder) {
        this.v5v_1 = $builder;
        this.r5v_1 = $builder.r5n_1;
        this.s5v_1 = $builder.q5n_1.l38();
        this.t5v_1 = $builder.v5n_1;
        this.u5v_1 = $builder.s5n_1.l38();
      }
      o5o() {
        // Inline function 'kotlin.error' call
        var message = 'Call is not initialized';
        throw IllegalStateException().o(toString(message));
      }
      p5o() {
        return this.r5v_1;
      }
      q5o() {
        return this.s5v_1;
      }
      i5o() {
        return this.t5v_1;
      }
      b56() {
        return this.u5v_1;
      }
      a2p() {
        var tmp = this.v5v_1.t5n_1;
        var tmp0_elvis_lhs = tmp instanceof OutgoingContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.v5v_1.t5n_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    protoOf($).gw = get_coroutineContext;
    initMetadataForClass($, VOID, VOID, VOID, [HttpRequest()]);
    HttpRequest$1Class = $;
  }
  return HttpRequest$1Class;
}
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().uf();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().uf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
    ExpectSuccessAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
RequestError_instance = new (RequestError())();
ReceiveError_instance = new (ReceiveError())();
//endregion
//region block: exports
export {
  get_ExpectSuccessAttributeKey as get_ExpectSuccessAttributeKey20jj5fup38v1g,
  get_HttpCallValidator as get_HttpCallValidator3iji36qylbtbr,
  HttpResponseValidator as HttpResponseValidator2d6ie1tmzg8fi,
};
//endregion

//# sourceMappingURL=HttpCallValidator.mjs.map
